import * as React from "react";

const SvgHamburger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3.5 7.875c0-.483.392-.875.875-.875h19.25a.875.875 0 0 1 0 1.75H4.375a.875.875 0 0 1-.875-.875M3.5 14c0-.483.392-.875.875-.875h19.25a.875.875 0 0 1 0 1.75H4.375A.875.875 0 0 1 3.5 14m9.625 6.125c0-.483.392-.875.875-.875h9.625a.875.875 0 0 1 0 1.75H14a.875.875 0 0 1-.875-.875"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHamburger;